'use client';

import React from 'react';

function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(' ');
}

export function ToolShell({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div data-component-id="src/components/ui/ToolUI.tsx:16:9" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="16" data-component-end-line="16" data-component-file="ToolUI.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={cx('tool-shell', className)}>{children}</div>;
}

export function ToolSection({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div data-component-id="src/components/ui/ToolUI.tsx:28:4" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="28" data-component-end-line="30" data-component-file="ToolUI.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...props} className={cx('tool-section', className)}>
      {children}
    </div>
  );
}

export function ToolPreviewSurface({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div data-component-id="src/components/ui/ToolUI.tsx:43:4" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="43" data-component-end-line="45" data-component-file="ToolUI.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...props} className={cx('tool-preview-surface', className)}>
      {children}
    </div>
  );
}

export function ToolLabel({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <label data-component-id="src/components/ui/ToolUI.tsx:56:9" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="56" data-component-end-line="56" data-component-file="ToolUI.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%7D" className={cx('tool-label', className)}>{children}</label>;
}

export function ToolPrimaryButton({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button data-component-id="src/components/ui/ToolUI.tsx:65:4" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="65" data-component-end-line="67" data-component-file="ToolUI.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...props} className={cx('tool-primary-button', className)}>
      {children}
    </button>
  );
}

export function ToolSecondaryButton({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button data-component-id="src/components/ui/ToolUI.tsx:77:4" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="77" data-component-end-line="79" data-component-file="ToolUI.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" {...props} className={cx('tool-secondary-button', className)}>
      {children}
    </button>
  );
}

export function ToolDropzone({
  active = false,
  success = false,
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  active?: boolean;
  success?: boolean;
}) {
  return (
    <div data-component-id="src/components/ui/ToolUI.tsx:94:4" data-component-path="src/components/ui/ToolUI.tsx" data-component-line="94" data-component-end-line="104" data-component-file="ToolUI.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      {...props}
      className={cx(
        'tool-dropzone',
        active && 'tool-dropzone-active',
        success && 'tool-dropzone-success',
        className,
      )}
    >
      {children}
    </div>
  );
}
